module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer026"
    }
  }, [_c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What should be our desiderata, in designing a new human race? What existence do we wish for our descendants on this world?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Long")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" happy lives?")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Fair enough")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Yet")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" despite our technical wonders")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" that simple boon may prove hard to deliver")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Long ago")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Darwin and Malthus pointed out life’s basic paradox")]), _vm._v("—"), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("that all species carry inbuilt drives to try to overbreed")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" To fill even Eden with so many offspring that it ceases to be paradise")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" anymore")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Nature")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" in her wisdom")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" controlled this opportunistic streak with checks and balances")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Predators")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" parasites")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" and random luck routinely culled the excess")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" To the survivors")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" each new generation")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" went the prize")]), _vm._v("—"), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("a chance to play another round")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Then humans came")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Born critics")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" we wiped out the carnivores who preyed on us")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" and battled disease")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" With rising moral fervor")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" societies pledged to suppress cut-throat competition")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" guaranteeing to all a ")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("right to live and prosper")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In retrospect")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" we know awful mistakes were made with the best intentions on poor Mother Terra")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Without natural checks")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" our ancestors’ population boom overwhelmed her")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" But is the only alternative to bring back rule by tooth and claw? Could we")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" even if we tried?")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Intelligence is loose in the galaxy")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Power is in our hands")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" for better or worse")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" We can modify Nature’s rules")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" if we dare")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" but we cannot ignore her lessons")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "text-right-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("—from "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Apologia")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _vm._v(" by Lysos")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0022012e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781504086356-4.vue
// module id = 84
// module chunks = 0